/** @format */

export const QAEnvironment = {};
